import { render, staticRenderFns } from "./BeritaList.vue?vue&type=template&id=36178d5e"
import script from "./BeritaList.vue?vue&type=script&lang=js"
export * from "./BeritaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports